import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared/models/error';
import { UserPreferenceComponentNameType, UserPreferenceResultType } from '@shared/models/user-preference';

const getUserPreference = createAction(
  '[UserPreference] Get user preference data',
  props<{ componentName: UserPreferenceComponentNameType }>()
);
const getUserPreferenceSuccess = createAction(
  '[UserPreference] Get user preference data Success',
  props<{ componentName: UserPreferenceComponentNameType; preferences: UserPreferenceResultType }>()
);
const getUserPreferenceFail = createAction(
  '[UserPreference] Get user preference data Fail',
  props<{ componentName: UserPreferenceComponentNameType; errors: ErrorModel[] }>()
);

const updateUserPreference = createAction(
  '[UpdateUserPreference] update user preference data',
  props<{ componentName: UserPreferenceComponentNameType; preferences: UserPreferenceResultType }>()
);
const updateUserPreferenceSuccess = createAction(
  '[UpdateUserPreference] update user preference data Success',
  props<{ componentName: UserPreferenceComponentNameType; preferences: UserPreferenceResultType }>()
);
const updateUserPreferenceFail = createAction(
  '[UpdateUserPreference] update user preference data Fail',
  props<{ componentName: UserPreferenceComponentNameType; errors: ErrorModel[] }>()
);

export const UserPreferenceActions = {
  getUserPreference,
  getUserPreferenceSuccess,
  getUserPreferenceFail,
  updateUserPreference,
  updateUserPreferenceSuccess,
  updateUserPreferenceFail,
};
